



export const SectionIconBoxesLayout2 = () => {
  return (
    <>
     <section className="mt-40">
  <div className="container">
    <div className="flex justify-center">
      <div className="text-center lg:w-3/5">
        <h2 className="mb-12 text-[#011473]">Travel Advisory Blogs</h2>
      </div>
    </div>
    <div className="mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {/* Image 1 */}
      <div className="relative w-full max-w-md rounded border p-4 transform transition-transform duration-500 hover:scale-105 shadow-md">
        {/* Main Image */}
        <img
          className="h-48 w-full rounded-lg object-cover shadow-lg"
          src="canadas.jpg"
          alt="Main"
        />
        {/* Text for Image 1 */}
        <div className="ml-2 mt-5 text-left text-2xl font-bold text-black">
          Canada
        </div>
        <div className="ml-2 mt-2 text-left text-sm text-black">
          Discover the vast beauty and opportunities of Canada, a nation known for its high quality of life, diversity and natural landscapes. Canada offers a wide range of career and lifestyle options for newcomers.
        </div>
        {/* Read More Button */}
        <div className="mt-4 flex items-center">
          <a
            href="canadablog"
            className="flex items-center text-[#01012f] hover:text-[#01012f]"
          >
            <span className="ml-2 hover:text-red-500">Read more</span>
            <span className="inline-flex h-6 ml-2 w-6 items-center justify-center rounded-full border-2 border-[#01012f]">
              <span className="h-2 w-2 rotate-45 transform border-r-2 border-t-2 border-[#01012f]"></span>
            </span>
          </a>
        </div>
      </div>

      {/* Image 2 */}
      <div className="relative w-full max-w-md rounded border p-4 transform transition-transform duration-500 hover:scale-105 shadow-md">
        {/* Main Image */}
        <img
          className="h-48 w-full rounded-lg object-cover shadow-lg"
          src="australiaa.jpg"
          alt="Main"
        />
        {/* Text for Image 2 */}
        <div className="ml-2 mt-5 text-left text-2xl font-bold text-black">
          Australia
        </div>
        <div className="ml-2 mt-2 text-left text-sm text-black">
          Australia offers a laid-back lifestyle with world-class beaches, stunning natural wonders and robust job prospects. A great destination for those seeking adventure and growth opportunities in a thriving economy.
        </div>
        {/* Read More Button */}
        <div className="mt-4 flex items-center">
          <a
            href="australiablog"
            className="flex items-center text-[#01012f] hover:text-[#01012f]"
          >
            <span className="ml-2 hover:text-red-500">Read more</span>
            <span className="inline-flex h-6 ml-2 w-6 items-center justify-center rounded-full border-2 border-[#01012f]">
              <span className="h-2 w-2 rotate-45 transform border-r-2 border-t-2 border-[#01012f]"></span>
            </span>
          </a>
        </div>
      </div>

      {/* Image 3 */}
      <div className="relative w-full max-w-md rounded border p-4 transform transition-transform duration-500 hover:scale-105 shadow-md">
        {/* Main Image */}
        <img
          className="h-48 w-full rounded-lg object-cover shadow-md"
          src="usai.jpg"
          alt="Main"
        />
        {/* Text for Image 3 */}
        <div className="ml-2 mt-5 text-left text-2xl font-bold text-black">
          USA
        </div>
        <div className="ml-2 mt-2 text-left text-sm text-black">
          The USA is home to diverse cultures, cities and opportunities. From Silicon Valley to the heart of New York City, the United States offers endless possibilities for both personal and professional growth.
        </div>
        {/* Read More Button */}
        <div className="mt-4 flex items-center">
          <a
            href="usablog"
            className="flex items-center text-[#01012f] hover:text-[#01012f]"
          >
            <span className="ml-2 hover:text-red-500">Read more</span>
            <span className="inline-flex h-6 ml-2 w-6 items-center justify-center rounded-full border-2 border-[#01012f]">
              <span className="h-2 w-2 rotate-45 transform border-r-2 border-t-2 border-[#01012f]"></span>
            </span>
          </a>
        </div>
      </div>

      {/* Image 4 */}
      <div className="relative w-full max-w-md rounded border p-4 transform transition-transform duration-500 hover:scale-105 shadow-md">
        {/* Main Image */}
        <img
          className="h-48 w-full rounded-lg object-cover shadow-md"
          src="ukh.jpg"
          alt="Main"
        />
        {/* Text for Image 4 */}
        <div className="ml-2 mt-5 text-left text-2xl font-bold text-black">
          UK
        </div>
        <div className="ml-2 mt-2 text-left text-sm text-black">
          The United Kingdom offers a rich history, thriving job market and multicultural environment. Whether you're looking for a career in finance or arts, the UK is a dynamic hub for global talent.
        </div>
        {/* Read More Button */}
        <div className="mt-4 flex items-center">
          <a
            href="ukblog"
            className="flex items-center text-[#01012f] hover:text-[#01012f]"
          >
            <span className="ml-2 hover:text-red-500">Read more</span>
            <span className="inline-flex h-6 ml-2 w-6 items-center justify-center rounded-full border-2 border-[#01012f]">
              <span className="h-2 w-2 rotate-45 transform border-r-2 border-t-2 border-[#01012f]"></span>
            </span>
          </a>
        </div>
      </div>

      {/* Image 5 */}
      <div className="relative w-full max-w-md rounded border p-4 transform transition-transform duration-500 hover:scale-105 shadow-md">
        {/* Main Image */}
        <img
          className="h-48 w-full rounded-lg object-cover shadow-md"
          src="denmark.jpg"
          alt="Main"
        />
        {/* Text for Image 5 */}
        <div className="ml-2 mt-5 text-left text-2xl font-bold text-black">
          Denmark
        </div>
        <div className="ml-2 mt-2 text-left text-sm text-black">
          Denmark is known for its high standard of living, environmental consciousness and innovative industries. A great destination for those seeking work-life balance and a future in sustainable industries.
        </div>
        {/* Read More Button */}
        <div className="mt-4 flex items-center">
          <a
            href="denmarkblog"
            className="flex items-center text-[#01012f] hover:text-[#01012f]"
          >
            <span className="ml-2 hover:text-red-500">Read more</span>
            <span className="inline-flex h-6 ml-2 w-6 items-center justify-center rounded-full border-2 border-[#01012f]">
              <span className="h-2 w-2 rotate-45 transform border-r-2 border-t-2 border-[#01012f]"></span>
            </span>
          </a>
        </div>
      </div>

      {/* Image 6 */}
      <div className="relative w-full max-w-md rounded border p-4 transform transition-transform duration-500 hover:scale-105 shadow-md">
        {/* Main Image */}
        <img
          className="h-48 w-full rounded-lg object-cover shadow-md"
          src="newzalend.jpg"
          alt="Main"
        />
        {/* Text for Image 6 */}
        <div className="ml-2 mt-5 text-left text-2xl font-bold text-black">
          New Zealand
        </div>
        <div className="ml-2 mt-2 text-left text-sm text-black">
          New Zealand is a paradise for nature lovers and outdoor enthusiasts, with a thriving economy and welcoming locals. Whether you're looking for adventure or career opportunities, New Zealand offers the perfect balance.
        </div>
        {/* Read More Button */}
        <div className="mt-4 flex  items-center">
          <a
            href="newzelandblog"
            className="flex items-center text-[#01012f] hover:text-[#01012f]"
          >
            <span className="ml-2 hover:text-red-500">Read more</span>
            <span className="inline-flex h-6 ml-2 w-6 items-center justify-center rounded-full border-2 border-[#01012f]">
              <span className="h-2 w-2 rotate-45 transform border-r-2 border-t-2 border-[#01012f]"></span>
            </span>
          </a>
        </div>
      </div>
      {/* Add more blogs as necessary */}
    </div>
  </div>
</section>


    </>
  );
};

export default SectionIconBoxesLayout2;
